var map = {
	"./arrow-down.svg": 6775,
	"./arrow-left.svg": 5976,
	"./arrow-right.svg": 4503,
	"./arrow-up.svg": 8024,
	"./book.svg": 8060,
	"./building.svg": 1211,
	"./close.svg": 2069,
	"./coin.svg": 656,
	"./credit-card-gear.svg": 4053,
	"./dialogue.svg": 645,
	"./download.svg": 1199,
	"./face-id.svg": 1142,
	"./file.svg": 9997,
	"./files.svg": 3060,
	"./folder.svg": 6851,
	"./grid.svg": 1231,
	"./home.svg": 8966,
	"./hourglass.svg": 867,
	"./inbox.svg": 741,
	"./info.svg": 4267,
	"./list.svg": 3583,
	"./login.svg": 9626,
	"./logout.svg": 8333,
	"./menu.svg": 5066,
	"./minus.svg": 5649,
	"./mood-sad.svg": 9165,
	"./play.svg": 9421,
	"./plus.svg": 4147,
	"./profile.svg": 9750,
	"./receipt-long.svg": 4360,
	"./restore.svg": 4215,
	"./search.svg": 1087,
	"./server.svg": 1178,
	"./stars.svg": 742,
	"./text.svg": 2342,
	"./theme-dark.svg": 2811,
	"./theme-light.svg": 5297,
	"./trending-up.svg": 2402,
	"./user.svg": 5650,
	"./users.svg": 1901,
	"./volume.svg": 8673,
	"./widgets.svg": 1554,
	"./zoom-cancel.svg": 7925,
	"./zoom-check.svg": 7721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7521;